var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { configs } from '@app/configs';
import mixpanel from 'mixpanel-browser';
export const initializeMixpanel = () => {
    var _a;
    if (configs.MIXPANEL_TOKEN) {
        // To avoid getting very large amount of page views (e.g. changing stops, ...) query string and hash parameters are ignored.
        mixpanel.init(configs.MIXPANEL_TOKEN, {
            // Important for EU data residency since mixpanel disabled forwarding: https://docs.mixpanel.com/changelogs/2026-02-20-eu-forwarding-deprecation
            api_host: 'https://api-eu.mixpanel.com',
            'track_pageview': 'url-with-path',
            record_sessions_percent: (_a = configs.MIXPANEL_SESSION_RECORDING_PERCENTAGE) !== null && _a !== void 0 ? _a : 0,
            // By default all input elements are masked. Other elements are also masked if you mark them with the `data-sensitive` attribute.
            // This is useful for example for sensitive data like API Keys, credit card numbers, etc.
            record_mask_text_selector: `[data-sensitive='true']`,
            // @ts-expect-error
            record_min_ms: 8000,
            autocapture: false,
            record_heatmap_data: false,
        });
    }
};
const sha256 = (str) => __awaiter(void 0, void 0, void 0, function* () {
    const buf = yield crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
    return Array.prototype.map.call(new Uint8Array(buf), x => (('00' + x.toString(16)).slice(-2))).join('').slice(0, 16);
});
export const updateUserDataMixpanel = (user, company) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (configs.MIXPANEL_TOKEN) {
        const userIdHash = yield sha256(user._id);
        const planType = 'Shipper';
        mixpanel.identify(userIdHash);
        mixpanel.people.set({
            'Plan Type': planType,
            'Company Id': company._id,
            'Company Name': company.company,
            'Company Type': company.type,
            'Number of Trucks': company.numberOfTrucks,
            'Job Title': user.jobTitle,
            'Language Skills': (_a = user.spokenLanguages) === null || _a === void 0 ? void 0 : _a.join(', '),
            'Application Language': user.language,
            'Country': company.country,
            'Linked Google Auth ID': (_b = user.linkedGoogleAuth) === null || _b === void 0 ? void 0 : _b.id,
            'Is Shipper': true, // Mark all shipper portal users so we can filter their events out if needed.
        });
        mixpanel.register({
            'Plan Type': planType,
            'Company Name': company.company,
        });
    }
});
